import React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    fetchStart,
} from 'react-admin';
import {Paper, Button, Dialog, DialogActions, DialogContent, DialogContentText} from '@material-ui/core';
import errorMessage from "../helper/ErrorMessage";
import {
    TextField,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl
} from '@mui/material';

const PartyVerificationDeathButton = (record) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [reason, setReason] = useState('MANUAL_CONFIRMED');
    const [comment, setComment] = useState('');

    const popupAlert = (message) => {
        setAlertOpen(true);
        setAlertText(message);
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
    };

    const popupConfirm = () => {
        setConfirmOpen(true);
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const handleSave= () => {
        setLoading(true);
        dispatch(fetchStart());
        const body = {
            reason: reason,
            comment: comment,
            employeeId: record.id
        };

        sendRequest(body);
    };

    const sendRequest = (body) => {
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                'X-Session': localStorage.getItem('session')
            },
            body: JSON.stringify(body)
        };

        fetch(
            process.env.REACT_APP_BASE_ENTRYPOINT + '/api/employees/party/' + record.party.id + '/verification_death',
            requestOptions
        )
            .then((response) => {
                console.log(response);
                if (response.status >= 400) {
                    return Promise.reject();
                }

                return response.json();
            })
            .then((data) => {
                if (data.id) {
                    popupAlert('Інформація збережена');
                    setConfirmOpen(false);
                } else {
                    errorMessage(data, popupAlert);
                }

            })
            .catch(() => {
                popupAlert('Помилка надсилання запиту');
            });
    };

    const changeReason = (event) => {
        setReason(event.target.value);
    };

    const changeComment = (event) => {
        setComment(event.target.value);
    };

    return (
        <div>
            <Button
                variant="contained"
                disabled={false}
                onClick={popupConfirm}
                color="primary"
            >
                Актуалізувати
            </Button>

            <Dialog
                open={confirmOpen}
                onClose={handleConfirmClose}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="confirm-dialog-content">
                        Підтвердьте чи спростуйте інформацію про смерть співробітника.

                        <Paper elevation={3} style={{textAlign: 'left', padding: '10px'}} label="ЕЦП" multiline fullWidth={true}>
                            <div style={{marginBottom: '25px'}}>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        aria-label="gender"
                                        name="controlled-radio-buttons-group"
                                        value={reason}
                                        onChange={changeReason}
                                    >
                                        <FormControlLabel value="MANUAL_CONFIRMED" control={<Radio />} label="Підтвердити" />
                                        <FormControlLabel value="MANUAL_NOT_CONFIRMED" control={<Radio />} label="Спростувати" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div>
                                <div>
                                    <FormControl fullWidth>
                                        <TextField id="comment" label="Коментар" multiline={true} onChange={changeComment}/>
                                    </FormControl>
                                </div>
                            </div>
                        </Paper>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSave} variant="contained" color="primary">Надіслати</Button>
                    <Button onClick={handleConfirmClose} variant="contained">Відхилити</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={alertOpen}
                onClose={handleAlertClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-content">
                        {alertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAlertClose} variant="contained" color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default PartyVerificationDeathButton;